import { StatusCodes } from '@e3dc-react/shell/Libs'
import { WallboxHardwareDto } from '../dto/wallbox-hardware.dto'
import { WallboxHardwareModel } from '../models'
import { AuthFetchWithResponse } from '@e3dc-react/shell/Types'
import { fromHardwareDtoToModel } from '../transformers/wallbox-hardware'

export const getWallboxHardwareBulk = async (storageIds: string[], authFetch: AuthFetchWithResponse): Promise<WallboxHardwareModel[] | null> => {
  try {
    const response = await authFetch<WallboxHardwareDto>({ path: 'wallboxes/bulk', payload: { sn: storageIds } })
    if (response.status !== StatusCodes.OK) {
      return null
    }
    return fromHardwareDtoToModel(response.data) ?? null
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getWallboxHardware = async (storageId: string | undefined, authFetch: AuthFetchWithResponse): Promise<WallboxHardwareModel[] | null> => {
  if (!storageId) throw new Error('Storage Id must be defined')
  try {
    const response = await authFetch<WallboxHardwareDto>({ path: `wallboxes/${storageId}` })
    if (response.status !== StatusCodes.OK) {
      return null
    }
    return fromHardwareDtoToModel(response.data)
  } catch (err) {
    console.error(err)
    return null
  }
}
